<div style="width: 100%; height: 100%;">
  <div #refCard class="fila-Atendimento" [class.reduzir-height]="showListaContato || showAssunto">
    <mat-card-title *ngIf="BoolDepartamentoGeral == true" class="card-title-font">
      Fila de Atendimento
    </mat-card-title>
    <div style="height: 28px;" *ngIf="BoolDepartamentoGeral == false"></div>
    <mat-card-subtitle class="card-subtitle-font">
      <mat-select *ngIf="BoolDepartamentoGeral == false" [disabled]="habilitaTrocarFila == true"
        [(ngModel)]="opcaoSelecionada" (selectionChange)="alterarDepartamento(opcaoSelecionada)">
        <mat-option *ngFor="let equipe of EquipeFila" [value]="equipe">
          {{equipe.Departamento}} - {{equipe.Filial}}
        </mat-option>
      </mat-select>
      <mat-hint style="color: rgb(0, 0, 0); font-size: 10px;"
        *ngIf="BoolDepartamentoGeral == false && habilitaTrocarFila == true">Não é possível trocar de fila no meio do
        atendimento.</mat-hint>

      <div *ngIf="BoolDepartamentoGeral == true">{{EquipeFila[0].Departamento}}</div>
    </mat-card-subtitle>
    <!-- <form [formGroup]="formFila">
  <div class="row d-flex justify-content-start" style="width: 100%">
    <mat-form-field>
      <mat-label>Nº de Clientes</mat-label>
      <input matInput formControlName="NClientes" readonly type="text">
    </mat-form-field>
  </div>

  </form> -->



    <mat-tab-group mat-align-tabs="center">
      <!-- Aba Em Espera -->
      <mat-tab [label]="labelAbaFila">

        <div class="table-container" *ngIf="dataSourceEmEspera.data.length > 0 && FilaAtendimento.state == 'Connected'">
          <mat-card (click)="AbrirPaginaPergunta(user)" class="user-fila-card" style="border-width: 1px;"
            *ngFor="let user of dataSourceEmEspera.data; let i = index">
            <div class="row">
              <div class="col-12 col-sm-1"></div>
              <div class="col-12 col-sm-12">

                <div class="row ">
                  <b>{{user?.NomeUsuarioWpp}}</b>
                </div>
                <div class="row">
                  <div class="font-small" *ngIf="user?.nomeCliente != null">Cliente - {{user?.nomeCliente}}</div>
                  <div class="font-small" *ngIf="user?.nomeCliente == null">Cliente - Sem cadastro</div>
                </div>
                <div class="row justify-content-end font-small">Tempo de espera: {{user?.Cronometro}}</div>
                <div class="row font-status">
                  <mat-icon *ngIf="user?.Status == 'Em espera'" class="green" fontIcon="check_circle">circle</mat-icon>
                  <mat-icon *ngIf="user?.Status == 'Em atendimento'" class="red"
                    fontIcon="check_circle">circle</mat-icon>
                  <mat-icon *ngIf="user?.Status == 'Transferência em espera'" class="yellow"
                    fontIcon="check_circle">circle</mat-icon>
                  {{user?.Status}}
                </div>
              </div>
            </div>
          </mat-card>

        </div>

        <div style="margin-top: 10px;"
          *ngIf="dataSourceEmEspera.data.length == 0 && FilaAtendimento.state == 'Connected'">
          Sem Clientes em espera nesta fila.
        </div>
      </mat-tab>


      <mat-tab *ngIf="BoolDepartamentoGeral == false" label="Em Atendimento">
        <div class="table-container">

          <div class="table-container"
            *ngIf="dataSourceEmAtendimento.data.length > 0 && FilaAtendimento.state == 'Connected'">
            <mat-card (click)="AbrirPaginaPergunta(user)" class="user-fila-card" style="border-width: 1px;"
              *ngFor="let user of dataSourceEmAtendimento.data; let i = index">
              <div class="row">
                <div class="col-12 col-sm-12">
                  <div *ngIf="user?.mensagensNaoRespondidas != 0" matBadge="{{user?.mensagensNaoRespondidas}}" matBadgeSize="small" matBadgeColor="warn" class="demo-section"></div>
                  <div class="row ">
                    <b>{{user?.NomeUsuarioWpp}}</b>
                  </div>
                  <div class="row">
                    <div class="font-small" *ngIf="user?.nomeCliente != null">Cliente - {{user?.nomeCliente}}</div>
                    <div class="font-small" *ngIf="user?.nomeCliente == null">Cliente - Sem cadastro</div>
                  </div>
                  <div class="row justify-content-between font-small">
                    <div>{{user?.UsuarioAtendente}}</div>
                    <div> Tempo de espera: {{user?.Cronometro}}</div>
                  </div>

                  <div class="row font-status" style="width: 90%;">
                    <mat-icon *ngIf="user?.Status == 'Em espera'" class="green"
                      fontIcon="check_circle">circle</mat-icon>
                    <mat-icon *ngIf="user?.Status == 'Em atendimento'" class="red"
                      fontIcon="check_circle">circle</mat-icon>
                    <mat-icon *ngIf="user?.Status == 'Transferência em espera'" class="yellow"
                      fontIcon="check_circle">circle</mat-icon>
                    {{user?.Status}}
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
        </div>

        <div style="margin-top: 10px;"
          *ngIf="dataSourceEmAtendimento.data.length == 0 && FilaAtendimento.state == 'Connected'">
          Sem Clientes em atendimento nesta fila.
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="d-flex justify-content-center" *ngIf="FilaAtendimento.state == 'Reconnecting'">
      <br>
      <h6>Conexão instável... Reconectando...</h6>
      <mat-spinner disabled [diameter]="50" style="margin-left: 3px" class="mat-spinner-color"></mat-spinner>
    </div>

    <div class="d-flex justify-content-center" *ngIf="FilaAtendimento.state == 'Disconnected'">
      <br>
      <h6>Não foi possível reestabelecer a conexão, verifique a rede.</h6>
    </div>

  </div>


</div>

